import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-notification';
export default class UnityNotification extends Component {
    constructor() {
        super(...arguments);
        this.notificationRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProperties();
        };
        this.componentDidUpdate = () => {
            this.updateProperties();
        };
        this.updateProperties = () => {
            const { props, notificationRef } = this;
            const unityNotification = notificationRef.current;
            const { onClose } = props;
            if (!!unityNotification) {
                if (!!onClose)
                    unityNotification.onClose = onClose;
            }
        };
    }
    render() {
        const { notificationRef, props } = this;
        return (React.createElement("unity-notification", Object.assign({ ref: notificationRef }, props)));
    }
}
